import React from 'react';
import CustomBox from '../Common/CustomBox';
import { HorizontalDivider } from '../Common/CustomDivider';
import DetailsHeader from '../Common/DetailsHeader';
import { QualificationItem, QualificationItemProps } from './QualificationItem';

interface QualificationSectionProps {
    header: string;
    items: QualificationItemProps[];
}
function QualificationSection({ header, items }: QualificationSectionProps): React.JSX.Element {
    return (
        <>
            <DetailsHeader label={header} />
            <HorizontalDivider />
            <CustomBox>
                <div className="flex flex-col gap-4">
                    {items.map((item) => (
                        <QualificationItem key={item.period} {...item} />
                    ))}
                </div>
            </CustomBox>
        </>
    );
}

export default QualificationSection;
